// Charger Firmware translations for React Admin resource
export const chargerFirmwareResource = {
  name: '充電樁韌體 |||| 充電樁韌體',
  fields: {
    id: 'ID',
    version: '版本',
    description: '說明',
    vendor: '廠商',
    model: '型號',
    file: '韌體檔案',
    file_name: '檔案名稱',
    file_size: '檔案大小',
    file_url: '檔案連結',
    charger_models: '相容型號',
    is_active: '啟用',
    release_notes: '版本說明',
    created_at: '上傳時間',
    uploaded_at: '上傳時間',
    updated_at: '更新時間',
  },
};

// Custom firmware translations for components
export const chargerFirmware = {
  subtitle: '管理充電樁韌體檔案',
  validation: {
    version_required: '版本為必填欄位',
    file_required: '韌體檔案為必填欄位',
    file_url_required: '請輸入有效的 http(s) 連結',
    invalid_file_type: '無效的檔案類型。僅允許 .bin、.hex、.fw、.rbl 檔案',
  },
  helpers: {
    version: '輸入韌體版本（例如：1.2.3）',
    description: '描述此韌體版本的修復內容或改進項目',
    vendor: '選擇充電樁廠商（從已連接的充電樁中獲取）',
    model: '選擇此廠商的充電樁型號',
    select_vendor_first: '請先選擇廠商',
    charger_models: '選擇此韌體相容的充電樁型號',
    file_upload: '上傳韌體二進位檔案',
    file_url: '充電樁下載韌體的完整連結（例如：http://example.com/firmware.bin）',
    url_warning: '只有當充電樁無法從 https 下載時才使用此選項。連結會原樣傳送給充電樁，請確保檔案會持續存放於此網址。',
  },
  sections: {
    basic_info: '韌體資訊',
    file_upload: '韌體檔案',
    firmware_source: '韌體來源',
    compatibility: '相容性',
  },
  source: {
    upload: '上傳檔案',
    url: '外部連結',
  },
  actions: {
    upload: '上傳韌體',
    download: '下載',
  },
  create: {
    title: '上傳新韌體',
    subtitle: '上傳新的充電樁韌體檔案',
  },
  edit: {
    title: '編輯韌體詳情',
    subtitle: '修改韌體其他資料',
    fileUploadWarning: '如需上傳新的韌體檔案，請建立新的韌體項目。',
  },
  list: {
    title: '韌體檔案',
    filters: {
      search: '搜尋版本或說明',
    },
    empty: {
      title: '找不到韌體檔案',
      subtitle: '上傳您的第一個韌體檔案以開始管理充電樁更新。',
    },
  },
  notifications: {
    uploaded: '韌體儲存成功',
    uploading: '正在上傳韌體檔案…',
    saving: '正在儲存韌體…',
    updated: '韌體更新成功',
    deleted: '韌體刪除成功',
    error: {
      upload: '韌體上傳失敗',
      update: '韌體更新失敗',
      delete: '韌體刪除失敗',
      file_too_large: '檔案大小超過最大允許大小',
      load_vendors_models: '無法載入充電樁廠商和型號',
      duplicate_version: '此廠商和型號已存在相同的韌體版本',
    },
  },
};
